<template>
    <div class="row">
        <div class="mx-auto col-md-12">
            <div class="card p-3 mb-3">
                <div class="card-body">
                    <b-card
                        class="mb-2"
                        header="Beneficiários">
                        
                        <div class="row mb-2">
                            <div class="col-2">
                                <b-input placeholder="ID Família" v-model="id"></b-input>
                            </div>
                            <div class="col">
                                <b-input placeholder="CPF" v-model="cpf_requerente"></b-input>
                            </div>
                            <div class="col-3">
                                <b-input placeholder="Nome" v-model="nome_completo"></b-input>
                            </div>
                            <div class="col-3">
                                <b-input placeholder="Nome da mãe" v-model="nome_mae"></b-input>
                            </div>
                            <div class="col text-right">
                                <b-button variant="primary" @click="pesquisar">                                        
                                        <font-awesome-icon
                                            :icon="['fas','search']"
                                        /> Pesquisar
                                </b-button>
                            </div>
                        </div>

                        <b-table
                            no-provider-paging
                            small
                            responsive
                            :empty-text="tabela.emptyText"
                            :fields="tabela.fields"
                            :items="tabela.items"
                            :show-empty="tabela.showEmpty"
                            :striped="tabela.striped">

                            <template v-slot:cell(data_nascimento)="data">
                                {{$helpers.formatDateHourToDate(data.value)}}
                            </template>
                            <template v-slot:cell(ind_ativo)="data">
                                <b-badge v-if="data.value == 'A'" variant="success">Ativo</b-badge>
                                <b-badge v-else-if="data.value == 'I'" variant="danger">Inativo</b-badge>
                                <b-badge v-else variant="warning">Aguardando Confirmação</b-badge>
                            </template>
                            <template v-slot:cell(editar)="data">
                                <b-link 
                                    class="text-primary"
                                    style="font-size: 18px"
                                    @click.prevent="editar(data.item)">
                                        <font-awesome-icon
                                            :icon="['fas','user-edit']"
                                             title="Editar dados Beneficiário"
                                        />
                                </b-link>
                            </template>

                            <template v-slot:cell(editar_beneficios)="data">
                                <b-link  
                                    class="text-success"  
                                    style="font-size: 18px"                            
                                    @click.prevent="editarBeneficios(data.item)" 
                                    title="Editar Benefícios">
                                        <font-awesome-icon
                                            :icon="['fas','edit']"
                                            title="Editar Benefícios"
                                        />
                                </b-link>
                            </template>

                            <template v-slot:cell(controlar_pagamentos)="data">
                                <b-link  
                                    class="text-warning"  
                                    style="font-size: 18px"                            
                                    @click.prevent="controlarPagamentos(data.item)"
                                    title="Controlar Pagamentos">
                                        <font-awesome-icon
                                            :icon="['fas','dollar-sign']"
                                            title="Controlar Pagamentos"
                                        />
                                </b-link>
                            </template>

                            <template v-slot:cell(editar_conta)="data">
                                <b-link  
                                    class="text-secondary"  
                                    style="font-size: 18px"                            
                                    @click.prevent="editarConta(data.item)"
                                    title="Editar/Visualizar Conta">
                                        <font-awesome-icon
                                            :icon="['far','credit-card']"
                                            title="Editar/Visualizar Conta"
                                        />
                                </b-link>
                            </template>

                            <template v-slot:cell(alterar_cpf)="data">
                                <b-link  
                                    class="text-danger"  
                                    style="font-size: 18px"                            
                                    @click.prevent="alterarResponsavel(data.item)"
                                    v-if="data.item.ind_ativo =='P' && 
                                        ($store.getters.userRoles.includes($constantes.usuario.ROLES.SUPERADMINISTRADOR) ||
                                        $store.getters.userRoles.includes($constantes.usuario.ROLES.ADMINISTRADOR_RF))"
                                    title="Confirmar Alteração Responsável">
                                        <font-awesome-icon
                                            :icon="['fas','users-cog']"
                                        />
                                </b-link>
                            </template>
                        </b-table>

                        <b-pagination 
                            align="right" 
                            :total-rows="tabela.totalRows" 
                            v-model="currentPage" 
                            :per-page="tabela.per_page"
                            class="mt-3">
                        </b-pagination>

                    </b-card>
                </div>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPage: 1,
            tabela: {
                items: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID Família',
                        class: 'text-center'                                                                                                                 
                    },
                    {
                        key: 'cpf_requerente',
                        label: 'CPF',
                        class: 'text-center'                                                                                                                 
                    },
                    {
                        key: 'nome_completo',
                        label: 'Nome completo',
                        class: 'text-center'                                                                                                                 
                    },
                    {
                        key: 'nome_mae',
                        label: 'Nome da mãe',
                        class: 'text-center'                                                                                                                 
                    },
                    {
                        key: 'data_nascimento',
                        label: 'Data Nascimento', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'ind_ativo',
                        label: 'Situação', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'origem_familia',
                        label: 'Origem família', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'editar',
                        label: '', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'editar_beneficios',
                        label: '', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'controlar_pagamentos',
                        label: '', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'editar_conta',
                        label: '', 
                        class: 'text-center'                                               
                    },
                    {
                        key: 'alterar_cpf',
                        label: '', 
                        class: 'text-center'                                               
                    },
                ],
                showEmpty: true,
                emptyText:'Nenhum registro encontrado',
                striped: true,             
                per_page: null,
                totalRows: 0, 
            },
            cpf_requerente: '',
            nome_completo: '',
            nome_mae: '',
            id:''
        }
    },
    methods: {
        pesquisar() {
            if(this.currentPage == 1){
                this.listar();
            }else{
                this.currentPage = 1;
            }
            
        },
        async listar() {
            
            try {
                let url = `familias?page=${this.currentPage}&id=${this.id}&cpf_requerente=${this.cpf_requerente}&nome_completo=${this.nome_completo}&nome_mae=${this.nome_mae}`;
                const result = await this.$api.get(url);
                this.tabela.items = result.data.dados.data;
                this.tabela.totalRows = result.data.dados.total;
                this.currentPage = result.data.dados.current_page;
                this.tabela.per_page = result.data.dados.per_page;

            }catch(error) {
                if(error.response.data){                        
                    this.$helpers.showToast(this,'Erro', error.response.data.message, 'danger');
                }
            }

        },

        editarBeneficios(beneficiario){            
            this.$router.push({ name: 'beneficiosbeneficiarioForm', params: { id: beneficiario.id} }); 
        },

        editar(beneficiario) {
            this.$router.push("/admin/beneficiarios/"+beneficiario.id);
        },

        controlarPagamentos(beneficiario){            
            this.$router.push({ name: 'controlePagamentos', params: { id: beneficiario.id, beneficiario:beneficiario} }); 
        },

        editarConta(beneficiario){            
            this.$router.push({ name: 'contaBancaria', params: { id: beneficiario.id, beneficiario:beneficiario} }); 
        },

        alterarResponsavel(beneficiario){            
            this.$router.push({ name: 'beneficiarioFormAlterarResponsavel', params: { dados: beneficiario, origem:"admin"} }); 
        },
    },
    watch: {
        currentPage() {
            this.listar();
        }
    },
    mounted() {
        this.listar();
    }
}
</script>